module.exports = __webpack_public_path__ + "static/img/intro-bg.a48cfde.gif";


//////////////////
// WEBPACK FOOTER
// ./static/images/introduce/intro-bg.gif
// module id = TsVx
// module chunks = 1